import React, {useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const iframeOrigin = 'https://frontline.readyplayer.me';

const Edit3dAvatarModal = observer(() => {
    const {modalStore, generalStore} = useStores();

    const [modelUrl, setModelUrl] = useState(null);
    const iframeRef = useRef(null);

    useEffect(() => {
        if (!!modelUrl) {
            modalStore.isUseAsRegularAvatarModalOpen = true;
        }
        // eslint-disable-next-line
    }, [modelUrl]);

    async function process3DModel(asRegularAvatar) {
        onModalClose();
        const promise = generalStore.update3DAvatar(modelUrl, asRegularAvatar);
        const errorMessage = generalStore.translate('cannotSave3dAvatar');
        const loadingMessage = generalStore.translate('processing') + '...';
        const successMessage = generalStore.translate('3dAvatarSaved');
        await modalStore.runAsync(promise, errorMessage, successMessage, loadingMessage);
    }


    function onModalOpen() {
        window.addEventListener("message", message, false);
    }

    function onModalClose() {
        modalStore.isEdit3dAvatarModalOpen = false;
        setModelUrl(null);
        window.removeEventListener("message", message, false);
    }

    function message(event) {
        if (event.origin !== iframeOrigin) {
            return;
        }
        setModelUrl(event.data);
    }

    function useAsRegularAvatarDialog() {

        function closeAndContinue(asRegularAvatar) {
            modalStore.isUseAsRegularAvatarModalOpen = false;
            process3DModel(asRegularAvatar).then();
        }

        return (
            <Dialog
                className='dialog blue-dialog'
                open={modalStore.isUseAsRegularAvatarModalOpen}
                PaperProps={{className: 'dialog-paper'}}
                onClose={(e, reason) => {
                    if (['backdropClick', 'escapeKeyDown'].includes(reason)) {
                        return;
                    }
                    modalStore.isUseAsRegularAvatarModalOpen = false;
                }}
            >

                <DialogTitle className='dialog-header'>{generalStore.translate('useThisAvatar')}</DialogTitle>
                <DialogContent className='dialog-body'>
                    {generalStore.translate('useAvatarSentence')} <br/>
                    {generalStore.translate('confirmUseAvatarSentence')}
                </DialogContent>
                <DialogActions className='dialog-buttons'>
                    <Button
                        variant='contained'
                        className='cancel-button'
                        onClick={() => closeAndContinue(false)}
                    >
                        {generalStore.translate('no')}
                    </Button>
                    <Button
                        variant='contained'
                        className='ok-button'
                        onClick={() => closeAndContinue(true)}
                    >
                        {generalStore.translate('yes')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    return (
        <Dialog
            open={modalStore.isEdit3dAvatarModalOpen}
            className='dialog edit-3d-avatar-dialog'
            onClose={onModalClose}
            TransitionProps={{
                onEnter: onModalOpen
            }}
        >

            <IconButton onClick={onModalClose} className='close-button'>
                <CloseIcon/>
            </IconButton>
            <iframe ref={iframeRef} className='avatar-iframe' src={iframeOrigin} allow='camera *; microphone *'
                    title='avatar-iframe'/>
            {useAsRegularAvatarDialog()}
        </Dialog>
    );
});

export default Edit3dAvatarModal;
